function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M240.9 269.5H42.5V14.2h133.9l64.5 72.4v182.9zM71 241h141.4V97.4l-48.8-54.7H71V241z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.7 127.6h-41.9c-15.8 0-28.6 12.9-28.7 28.7v41.9c0 15.8 12.9 28.6 28.7 28.7h41.9c15.8 0 28.6-12.9 28.7-28.7v-41.9c-.1-15.9-12.9-28.7-28.7-28.7zm-56.1 49.7v-21.1c0-7.8 6.3-14.2 14.2-14.2H149v70.2h-14.3v-35l-28.1.1zm56.5-21.3v-13.9c7.6.2 13.6 6.4 13.7 13.9h-13.7zm0 28.5v-14.3h13.7v14.3h-13.7zm-42.6 27.8c-7.7-.1-13.9-6.4-13.9-14.1v-6.7h13.9v20.8zm42.6 0v-13.6h13.7c-.3 7.4-6.3 13.3-13.7 13.6z"
})));